export const environment = {
  sentryEnabled: true,
  sentryDsn: 'https://7bd87c01c5da4a6ea01a6bd17b5a960b@o762111.ingest.us.sentry.io/4504683585994752',
  sentryEnvironment: 'development',
};
